export enum Tabs {
  SearchCoin = 'Search Coin',
  PredefinedBaskets = 'Predefined Baskets',
  CopyMeBaskets = 'Copy Me Baskets',
}
